<!--
 * @Author: 赵克强 huohuo625@163.com
 * @Date: 2023-06-13 14:35:42
 * @LastEditors: 赵克强 huohuo625@163.com
 * @LastEditTime: 2023-06-13 14:39:55
 * @FilePath: \zhixing-heyue-erp-front-end-pc\src\assets\icons\cj.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

  <template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="18" viewBox="0 0 20 18">
  <image id="厂家" width="20" height="18" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAABVUlEQVQ4jbXUPUscURTG8Z/RIpY2kv0CQuqtFTRiESH4AVIkgYiIiiniZ7DIBqJGMJA3REgTEF0EQbTQwtY+aqudaGMSfGHkbLgM6+4o5IFhzrkvf5577plpKZfLCugLHuFps6VtBWCf8DLiTfQ1WvygCayC1/iOafSiel+HCxjGKl7E2ENMYgP9d3E4E7AdPEvG3+AbnmC9KPAzxrGG7jrzWT1nMRA1bQjMnL3CFgZvcZ9pAl+jpivpRNo2i3gecTvOGwBrOkYnttGTOpxPYJdR/FQf8KMO8CLe3VGiG4fvo9jvAjSGEo6SjVe1E6WnC+BP7Mb+aubwAEt4i5NbjrYfzvNqCROVaLO9rA/n4snUVaBueZUiH1Hnlv/cA/g3TZp9enfWfwe2xju94UyFS5H/OdTyjziLOGuZxxEPYTm3p6MR8FeARnPjv8PlVA54isN/Ga4BTOc/vk8fzaAAAAAASUVORK5CYII="/>
</svg>

</template>
